import { CAMPAIGN_STATUS_COLORS } from "../../../utils/colors";
import { toScreamingSnakeCase } from "../../../utils/constants";
import { CAMPAIGN_DATE_TIME_FORMAT, CAMPAIGN_DATE_TIME_SECONDS_FORMAT, CAMPAIGN_STATUS } from "./campaignConstant";
import moment from "moment-timezone";

export const getExecutionColor = (executionStatus, flagLightColor) => {
    if (executionStatus) {
        let executionStatusName = toScreamingSnakeCase(executionStatus);
        const defaultColorObj = CAMPAIGN_STATUS_COLORS["DEFAULT"];

        const statusColorObj = CAMPAIGN_STATUS_COLORS[CAMPAIGN_STATUS[executionStatusName]];
        return flagLightColor ? statusColorObj.BG_COLOR ?? defaultColorObj.BG_COLOR : statusColorObj.TEXT_COLOR ?? defaultColorObj.TEXT_COLOR;
    }
}



export const allowedExecutionContactStatus = ['Delivered', 'Read', 'Sent', 'Failed', 'Pending', 'Clicked', 'Replied']

export const isCampaignStatusPaused = (status) => {
    return status?.toLowerCase() == CAMPAIGN_STATUS["PAUSED"]?.toLowerCase();
}

export const isCampaignStatusCompleted = (status) => {
    return status?.toLowerCase() === CAMPAIGN_STATUS["COMPLETED"]?.toLowerCase();
} 

export function getUtcOffsetMinutesFromTimezoneHour(timeZone) {
    const offsetMatch = String(timeZone ?? "").match(/^UTC([+-]\d{1,2}):?(\d{2})?$/);
    if (offsetMatch) {
        const offsetHours = parseInt(offsetMatch[1], 10);
        const offsetMinutes = parseInt(offsetMatch[2] || "0", 10);
        return offsetHours * 60 + (offsetHours < 0 ? -offsetMinutes : offsetMinutes);
    }
    return new Date().getTimezoneOffset() * -1;
}

export function convertDateLocalAndUTC(input, toUTC = true, format = CAMPAIGN_DATE_TIME_SECONDS_FORMAT, timeZone) {
    // Detect format if not provided (optional enhancement; currently using explicit `format`)
    let inputFormat = format;
    const offsetMinutes = getUtcOffsetMinutesFromTimezoneHour(timeZone);
    const useUserTimezone = Boolean(timeZone);

    // If input is only time (like "10:35"), prepend today's date in the target timezone
    if (/^\d{2}:\d{2}(:\d{2})?$/.test(input)) {
        const today = useUserTimezone
            ? moment.utc().utcOffset(offsetMinutes).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD");
        input = `${today} ${input}`;
        inputFormat = input.length === 13 ? CAMPAIGN_DATE_TIME_FORMAT : CAMPAIGN_DATE_TIME_SECONDS_FORMAT;
    }

    let date;
    if (toUTC) {
        // Interpret input as user/local wall-clock time, convert to UTC
        date = moment(input, inputFormat).utcOffset(offsetMinutes, useUserTimezone).utc();
    } else {
        // Interpret input as UTC, convert to user/local time
        date = moment.utc(input, inputFormat).utcOffset(offsetMinutes);
    }

    return date.format(format);
}